module.exports = __webpack_public_path__ + "img/bell_2.0f971784.jpg";